import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { SafeHtmlPipe } from "../shared/safe-html/safe-html";

@Component({
  selector: 'app-e-devlet-giris-gerekli',
  standalone: true,
  imports: [TohumUiModule, SafeHtmlPipe],
  templateUrl: './e-devlet-giris-gerekli.component.html'
})
export class EDevletGirisGerekliComponent implements OnInit {

  constructor(private tokenExtractor: HttpXsrfTokenExtractor, private http: HttpClient, @Inject(DOCUMENT) private document: any) { }

  ngOnInit(): void {
  }

  logout() {
    const token = this.tokenExtractor.getToken() as string;
    let headers = new HttpHeaders();
    if (token !== null) {
      headers = headers.append('X-XSRF-TOKEN', token);
    }

    this.http.get<any>('/auth/oauth/logout', { headers }).subscribe(result => {
      this.document.location.href = result.data.redirectUrl;
    });
  }

}
